/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmAccountStatusEnum } from './ccmAccountStatusEnum';
import { CcmAccountOnboardedByEnum } from './ccmAccountOnboardedByEnum';


/**
 * Response after creating/onboarding an account
 */
export interface CloudCostMgmtAccountCreateResponse { 
    /**
     * AWS Account ID
     */
    account_id: string;
    /**
     * Organization ID
     */
    org_id?: string;
    /**
     * Organization name
     */
    org_name?: string;
    /**
     * Whether cleanup is enabled
     */
    cleanup_enabled: boolean;
    status: CcmAccountStatusEnum;
    onboarded_by: CcmAccountOnboardedByEnum;
    /**
     * Timestamp when the account was created
     */
    created_ts: Date;
}
export namespace CloudCostMgmtAccountCreateResponse {
}


